import React, {useEffect, useState} from "react";
import Swiper from 'react-id-swiper';
import {ReactIdSwiperChildren} from "react-id-swiper/lib/types";

// Full list of params https://swiperjs.com/api/#parameters
interface SwiperJSType {
    slideTo: Function,
    update: Function
}

// Full list of params https://swiperjs.com/api/#parameters
interface SwiperJSProps {
    allowTouchMove: boolean
    simulateTouch: boolean
}

interface Props {
    children: ReactIdSwiperChildren,
    page?: number
}

function Pager(props: Props) {

    const [swiper, setSwiper] = useState<SwiperJSType | null>(null);

    const swiperJSProps: SwiperJSProps = {
        allowTouchMove: false,
        simulateTouch: false
    };

    useEffect(() => {

        // To fix a bug where the swiper does not take full width
        swiper && swiper.update();

    }, [swiper]);

    useEffect(() => {

        swiper && swiper.slideTo(props.page);

    }, [swiper, props.page]);

    return (
        <Swiper getSwiper={setSwiper} {...swiperJSProps} children={props.children}/>
    );

}

export default Pager;
